export default __webpack_public_path__ + "static/media/06-isologotipo-para-fondo-blanco.b61a684e.png";